import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={22}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.6} fill="#0009">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9.08 8.444 6.524 6.525 8.441 9.083 11l-2.558 2.557 1.918 1.918 2.558-2.557 2.557 2.557 1.918-1.918-2.558-2.557 2.558-2.558-1.918-1.918L11 9.081Z"
      />
      <path d="M5.14 16.86A8.288 8.288 0 1 0 16.86 5.14 8.288 8.288 0 0 0 5.14 16.86Zm-1.918 1.918c-4.296-4.295-4.296-11.26 0-15.556 4.296-4.296 11.26-4.296 15.556 0 4.296 4.296 4.296 11.26 0 15.556-4.295 4.296-11.26 4.296-15.556 0Z" />
    </g>
  </svg>
);

export default SvgComponent;
